'use client';

import { Label } from '@wolfejs/ui/Form/Label';
import { RadioGroup, RadioGroupItem } from '@wolfejs/ui/RadioGroup/RadioGroup';
import { cn } from '@wolfejs/ui/utils/classnames';

export type RadioGroupOption = { id: string; name: string | React.ReactNode };

export type TabRadioGroupProps = {
  className?: string;
  options: RadioGroupOption[];
  selectedOption: string;
  onChange: (option: string) => void;
};

export default function TabRadioGroup({ className, options, selectedOption, onChange }: TabRadioGroupProps) {
  return (
    <>
      <RadioGroup
        className={cn('border-default-100 flex flex-wrap border-b', className)}
        value={selectedOption}
        onValueChange={onChange}
      >
        {options.map(option => (
          <div
            className={cn('flex items-center gap-0.5 space-x-2 px-2 pb-2', {
              'border-primary border-b': selectedOption === option.id,
            })}
            key={option.id}
          >
            <RadioGroupItem
              className={cn('bg-white text-sm font-medium focus:outline-none', {
                'bg-primary': selectedOption === option.id,
              })}
              value={option.id}
              id={option.id}
            />
            <Label className="flex items-center gap-2" htmlFor={option.id}>
              {option.name}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </>
  );
}
